export default "__VITE_ASSET__BFc87pRH__"